/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ChunkingInputs */

const en_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking`)
};

const ar_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقطيع`)
};

const bn_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চাঙ্কিং`)
};

const de_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking`)
};

const es_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentación`)
};

const fr_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morceau`)
};

const pt_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentação`)
};

const zh_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分块`)
};

const tr_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parçalama`)
};

const ru_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разбивка на части`)
};

const pl_svchip_chunking = /** @type {(inputs: Svchip_ChunkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porcjowanie`)
};

/**
* | output |
* | --- |
* | "Chunking" |
*
* @param {Svchip_ChunkingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_chunking = /** @type {((inputs?: Svchip_ChunkingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ChunkingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_chunking(inputs)
	if (locale === "bn") return bn_svchip_chunking(inputs)
	if (locale === "de") return de_svchip_chunking(inputs)
	if (locale === "es") return es_svchip_chunking(inputs)
	if (locale === "fr") return fr_svchip_chunking(inputs)
	if (locale === "pt") return pt_svchip_chunking(inputs)
	if (locale === "zh") return zh_svchip_chunking(inputs)
	if (locale === "tr") return tr_svchip_chunking(inputs)
	if (locale === "ru") return ru_svchip_chunking(inputs)
	if (locale === "pl") return pl_svchip_chunking(inputs)
	return en_svchip_chunking(inputs)
});